import React from 'react';
import { Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
// Selectors
import { selectIsAuthenticated } from 'store/auth/authSelectors';
import { selectCurrentUser } from 'store/users/usersSelectors';
// Models
import IUser from 'models/User';
// Types
import UserRoles from 'types/UserRoles';

type Props = {
  children: JSX.Element;
}

const PublicRoute:React.FC<Props> = ({
  // Props
  children
}) => {
  // State
  const isAuthenticated:boolean | null = useSelector(selectIsAuthenticated);
  const currentUser:IUser | null = useSelector(selectCurrentUser);

  if ( isAuthenticated ) return <Navigate to={currentUser?.activeRole === UserRoles.Owner ? '/my-timeshares' : '/reservations'} replace />;
  return children;
};

export default PublicRoute;
